import { Events } from "@type-r/models"
import { div, Flex, span, Button, asTimelessDate } from "lqx-react"
import React from "react"
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";

export const InsurancePoliciesCardRenderer = () =>
    ({ data, style, index }) => {
        const policyCard: any = data.items[ index ];
        const linkPolicies = ({ policyId }: { policyId }) => {
            Events.trigger('navigate', '/digitization/linkPolicy/' + policyId);
        }
        return (
            <Row style={ style }>
                <Flex row>
                    <Container >
                        <Body >
                            <Flex row>
                                <Flex column >
                                    <span><Bullet /><State>{ policyCard.status }  </State><PolicyName>{ policyCard.name }</PolicyName></span>
                                </Flex>
                                { (policyCard.status == "Bound" || policyCard.status == "Bound*") &&
                                    <>
                                        <Flex column grow><PolicyCardLabel> 0 linked invoices <PolicyCardDate> $0.00    </PolicyCardDate></PolicyCardLabel> </Flex>
                                        { Can(UserEntitlementCatalogs.LinkInvoices) &&
                                            <Flex column> <Button color="primary" onClick={ () => linkPolicies({ policyId: policyCard.id }) }>Link  Invoices</Button> </Flex> }
                                    </>
                                }
                            </Flex>
                            <Flex row grow>
                                <Flex column>
                                    <InsuredParty> { policyCard.insuredParty.name } - { (policyCard.status == "Bound" || policyCard.status == "Bound*") && policyCard.policyInsuranceCarriers.models.length > 0 ? policyCard.policyInsuranceCarriers.models[ 0 ].insuranceCarrierName : '' } </InsuredParty>
                                </Flex>
                            </Flex>
                        </Body>
                        <Footer >
                            <FooterProperty><FooterLabel>Inception Date:</FooterLabel> { asTimelessDate(policyCard.inceptionDate) }</FooterProperty>
                            <FooterProperty><FooterLabel>Expiration Date:</FooterLabel> { asTimelessDate(policyCard.expiryDate) } </FooterProperty>
                        </Footer>
                    </Container>
                </Flex>
            </Row>
        )
    }

const Row = div({
    width: '100%',
});

const Container = div({
    borderRadius: '5px',
    width: '100%',
    border: (props: any) => props.active === 'true' ? '1px solid #58C1EE' : '1px solid #F2F5F8'

});

const Body = div({
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    padding: '4px 10px',
    width: '100%',
    background: '#FFFFFF',
    height: '50px',
    backgroundColor: (props: any) => props.active === 'true' ? '#F4FAFD' : '#FFFFFF',
});

const Footer = div({
    width: '100%',
    borderTop: '2px solid #F2F5F8',
    borderLeft: '1px solid #F2F5F8',
    borderRight: '1px solid #F2F5F8',
    fontWeight: 500,
    fontSize: '12px',
    height: '28px',
    paddingTop: '5px',
    paddingLeft: '10px',
    overflow: 'hidden',
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
    backgroundColor: (props: any) => props.active === 'true' ? '#E7F2F9' : '#F9FAFC',
    color: '#3E4B5F',
    display: 'flex',
    justifyContent: 'flex-start'
});

const FooterProperty = span({
    flex: '0 0 200px'
});

const PolicyCardLabel = span({
    color: '#8695A4',
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: '26px',
    alignSelf: 'end',
    display: 'inline-flex',
    alignItems: 'center'
});

const PolicyName = span({
    color: '#bbc3cc',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    marginLeft: '5px'
});

const InsuredParty = span({
    color: 'black',
    fontSize: '13px',
    fontWeight: 600,
});

const PolicyCardDate = div({
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '15px',
    color: '#003c67',
    marginLeft: '6px'
});

const FooterLabel = span({
    fontWeight: 'normal',
    fontSize: '12px',
    color: '#829AB0',
});

const State = span({
    color: '#63a9dc',
    fontSize: '11px',
    fontWeight: 500,
    textAlign: 'left',
    paddingLeft: 3
});

const Bullet = div({
    display: 'inline-block',
    width: '6px',
    height: '6px',
    background: '#4297D6',
    borderRadius: '11px',
    verticalAlign: 'middle'
});
